module.exports = __webpack_public_path__ + "img/icon-flag.3289be6e.svg";